// extracted by mini-css-extract-plugin
export const facts = "intro-module--facts--3QLYL";
export const content = "intro-module--content--yCT-U";
export const supporters = "intro-module--supporters--1BHYw";
export const supporter = "intro-module--supporter--20wz-";
export const supporterImage = "intro-module--supporter-image--1KC3D";